import { Component } from "react"
import PropTypes from "prop-types"
import find from "lodash/find"
import extend from "lodash/extend"
import indexOf from "lodash/indexOf"
import keys from "lodash/keys"
import EndpointTestAssertions from "partners/components/endpoint_test/assertions"
import EndpointTestCaseMessage from "partners/components/endpoint_test/test_case_message"

import { post } from "shared/lib/api"

export default class AuthenticationTestEnsureTokenDoesNotExpire extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isShowing: false,
      status: "initial",
      errorMessage: "Could not refresh token, please try again.",
    }
    this.toggle = this.toggle.bind(this)
    this.refreshToken = this.refreshToken.bind(this)
    this.getStatusClass = this.getStatusClass.bind(this)
  }

  componentDidMount() {
    this.tokensReceivedListener = window.addEventListener(
      "tokensReceived",
      event => {
        this.setState(event.detail)
      }
    )

    this.tokenRefreshedListener = window.addEventListener(
      "tokenRefreshed",
      event => {
        this.setState(
          extend(event.detail, {
            status: "working",
            oldRefreshToken: this.state.refreshToken,
          })
        )
        this.refreshToken()
      }
    )
  }

  componentWillUnmount() {
    window.removeEventListener("tokenReceived", this.tokenReceivedListener)
    window.removeEventListener("tokenRefreshed", this.tokenRefreshedListener)
  }

  getStatusClass() {
    if (this.state.assertions) {
      return find(
        this.state.assertions,
        assertion => assertion.status === "failing"
      )
        ? "failing"
        : "passing"
    }
    return ""
  }

  refreshToken() {
    post(this.props.path, {
      oauth_refresh_token:
        this.state.oldRefreshToken || this.state.refreshToken,
    })
      .then(response => {
        const request = response.data.request
        const statusCode = response.data.response.statusCode
        let body = response.data.response.body
        try {
          body = JSON.parse(body)
        } catch (e) {} // eslint-disable-line no-empty
        const assertions = {
          status_code_200: {
            label: "Status Code is 200",
            status:
              indexOf([200, 201], statusCode) === -1 ? "failing" : "passing",
          },
          body_valid_json: {
            label: "Body is valid JSON",
            status: body && keys(body).length ? "passing" : "failing",
          },
          response_is_obj: {
            label: "Response is an object",
            status: body && typeof body === "object" ? "passing" : "failing",
          },
          token_provided: {
            label: "Access token is provided",
            status:
              body && body.access_token && typeof body.access_token === "string"
                ? "passing"
                : "failing",
          },
          token_length: {
            label: "Access token is at least one character long",
            status:
              body && body.access_token && body.access_token.length
                ? "passing"
                : "failing",
          },
        }
        if (body && body.expires_in) {
          assertions.expires_in_is_a_positive_number = {
            label: "Expires in is a positive number",
            status:
              typeof body.expires_in === "number" && body.expires_in > 0
                ? "passing"
                : "failing",
          }
        }
        this.setState({
          assertions,
          request,
          response: response.data.response,
          status: "completed",
        })
        window.dispatchEvent(
          new CustomEvent("statusReceived", {
            detail: {
              componentKey: "tokenNotExpire",
              componentStatus: this.getStatusClass(),
            },
          })
        )
      })
      .catch(response => {
        let errorMessage = this.state
        if (response.responseText) {
          try {
            errorMessage = JSON.parse(response.responseText).data.error.code
          } catch (e) {} // eslint-disable-line no-empty
        }
        this.setState({ status: "error", errorMessage })
        window.dispatchEvent(
          new CustomEvent("statusReceived", {
            detail: {
              componentKey: "tokenNotExpire",
              componentStatus: "failing",
            },
          })
        )
      })
  }

  toggle() {
    this.setState({ isShowing: !this.state.isShowing })
  }

  render() {
    const statusClass = this.getStatusClass()
    return (
      <div
        className={`endpoint publish-item ${statusClass} ${
          this.state.isShowing ? "expanded" : "collapsed"
        }`}
      >
        <header onClick={this.toggle}>
          Ensure older refresh token does not expire immediately
        </header>
        {this.state.isShowing ? (
          <div>
            {this.state.status === "completed" ? (
              <EndpointTestCaseMessage
                type="request"
                message={this.state.request}
              />
            ) : null}
            {this.state.status === "completed" ? (
              <EndpointTestCaseMessage
                type="response"
                message={this.state.response}
              />
            ) : null}
            {this.state.status === "completed" ? (
              <EndpointTestAssertions assertions={this.state.assertions} />
            ) : null}
            {this.state.status === "error" ? (
              <div>{this.state.errorMessage}</div>
            ) : null}
            {this.state.status === "working" ? <div>Working…</div> : null}
          </div>
        ) : null}
      </div>
    )
  }
}

AuthenticationTestEnsureTokenDoesNotExpire.propTypes = {
  service: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
}
